<template>
  <b-card class="shadow-sm">
    <b-card-body class="p-6">
      <div class="d-flex align-items-center mb-2">
        <div class="badge badge-pill badge-gold mr-4">
          <i class="fas fa-birthday-cake" style="font-size: 1.5rem" />
        </div>
        <div>
          <b-card-title class="mb-0">Aniversariantes</b-card-title>
          <small class="text-muted">{{ formattedToday }}</small>
        </div>
      </div>

      <!-- LOADING (skeletons como nos demais cards) -->
      <template v-if="loading">
        <ul class="list-unstyled m-0 p-0 mt-4">
          <li v-for="i in 5" :key="i" class="d-flex align-items-center mb-4">
            <div class="flex-grow-1">
              <b-skeleton width="40%" height="16px" />
              <b-skeleton width="25%" height="12px" class="mt-2" />
            </div>
            <div class="ml-3" style="width: 120px; text-align: right">
              <b-skeleton width="60px" height="24px" />
            </div>
          </li>
        </ul>
      </template>

      <!-- TABELA -->
      <template v-else>
        <b-table
          class="tabela-aniversariantes mt-4"
          :items="items"
          :fields="camposTabela"
          responsive="sm"
          small
          show-empty
          :empty-text="'Nenhum aniversariante hoje'"
        >
          <!-- Coluna Nome + data de nascimento -->
          <template #cell(nome_e_idade)="row">
            <div>{{ row.item.nome }}</div>
            <small class="text-muted">
              {{ formatDate(row.item.data_nascimento) }}
            </small>
          </template>

          <!-- Coluna Idade -->
          <template #cell(idade)="row">
            <span class="align-middle">{{ row.item.idade }}</span>
          </template>

          <!-- Coluna Ações -->
          <template #cell(acoes)="row">
            <b-btn
              v-if="row.item.telefone"
              size="sm"
              @click="
                openWhats(row.item.telefone, `Parabéns, ${row.item.nome}! 🎉`)
              "
              variant="secondary"
            >
              <b-icon icon="whatsapp" variant="primary" class="mr-1" />
              Parabenizar
            </b-btn>
            <div v-else class="text-muted mr-3" style="font-size: 0.9rem">
              Sem WhatsApp
            </div>
          </template>
        </b-table>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from "moment";

export default {
  name: "Aniversariantes",
  props: {
    /**
     * Aceita:
     * - { data: [{ nome, data_nascimento, idade, telefone? }, ...] }
     * - OU diretamente um array: [{...}, {...}]
     */
    dados: {
      type: [Object, Array],
      default: () => ({ data: [] }),
    },
    // controle externo de loading
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      camposTabela: [
        { key: "nome_e_idade", label: "Nome" },
        { key: "idade", label: "Idade", class: "align-middle" },
        { key: "acoes", label: "", class: "text-right align-middle" },
      ],
    };
  },

  computed: {
    items() {
      if (Array.isArray(this.dados)) return this.dados;
      if (this.dados && Array.isArray(this.dados.data)) return this.dados.data;
      return [];
    },
    formattedToday() {
      return new Date().toLocaleDateString("pt-BR", {
        weekday: "short",
        day: "2-digit",
        month: "short",
      });
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return "-";
      return moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "-";
    },

    // Normaliza número para E.164 BR (adiciona 55 se faltar)
    toE164BR(fone) {
      if (!fone) return null;
      let digits = String(fone).replace(/\D+/g, "");
      digits = digits.replace(/^0+/, ""); // remove zeros à esquerda
      if (digits.startsWith("55")) return digits;
      if (digits.length >= 10 && digits.length <= 11) return `55${digits}`;
      return `55${digits}`; // fallback
    },

    openWhats(fone, mensagem = "") {
      const e164 = this.toE164BR(fone);
      if (!e164) {
        if (this.$bvToast) {
          this.$bvToast.toast("Número inválido para WhatsApp.", {
            variant: "danger",
            solid: true,
          });
        } else {
          alert("Número inválido para WhatsApp.");
        }
        return;
      }
      const text = encodeURIComponent(mensagem || "");
      const url = text
        ? `https://wa.me/${e164}?text=${text}`
        : `https://wa.me/${e164}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.badge {
  width: 38px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.badge-gold {
  background-color: #f6d365;
}
</style>

<style>
.tabela-aniversariantes table thead th {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: rgb(248, 248, 248);
}
</style>
